import type { MouseEventHandler } from 'react';

import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';

import {
  CmsTileModalCloseButtonStyled,
  CmsTileModalCloseButtonText,
} from './CmsTileModalCloseButton.styled';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export function CmsTileModalCloseButton({ onClick }: Props) {
  const { i18n } = useI18n();

  return (
    <CmsTileModalCloseButtonStyled
      type="button"
      data-qa-id="cms-tile-grid-close-button"
      onClick={onClick}
    >
      <CmsTileModalCloseButtonText>{i18n('close')}</CmsTileModalCloseButtonText>

      <Icon name="close" size={24} />
    </CmsTileModalCloseButtonStyled>
  );
}
